import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]




export default /*#__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: {
	url: {
		type: String,
		default: 'https://ionicframework.com/docs/img/demos/avatar.svg'
	},
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: "h-8 w-8 rounded-full",
    src: props.url,
    alt: ""
  }, null, 8, _hoisted_1))
}
}

})